import { render, staticRenderFns } from "./TemplateComponent.vue?vue&type=template&id=8ea84a46&scoped=true"
import script from "./TemplateComponent.vue?vue&type=script&lang=js"
export * from "./TemplateComponent.vue?vue&type=script&lang=js"
import style0 from "./TemplateComponent.vue?vue&type=style&index=0&id=8ea84a46&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ea84a46",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8ea84a46')) {
      api.createRecord('8ea84a46', component.options)
    } else {
      api.reload('8ea84a46', component.options)
    }
    module.hot.accept("./TemplateComponent.vue?vue&type=template&id=8ea84a46&scoped=true", function () {
      api.rerender('8ea84a46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/quoteBuilder/components/TemplateComponent.vue"
export default component.exports